import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-silver"
}
const _hoisted_2 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_3 = { class: "admin-card h-100 d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "text-white text-capitalize mb-1" }
const _hoisted_5 = { class: "text-silver small mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createBlock(_component_AdminLayout, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", {
        class: "text-white mb-4",
        style: {"font-weight":"800"}
      }, "Content Sections", -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading sections..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (block) => {
              return (_openBlock(), _createElementBlock("div", {
                key: block.section,
                class: "col-md-6 col-lg-4"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.labelFor(block.section)), 1),
                    _createElementVNode("p", _hoisted_5, "Last updated: " + _toDisplayString(_ctx.formatDate(block.updated_at)), 1)
                  ]),
                  _createVNode(_component_RouterLink, {
                    to: '/admin/content/' + block.section,
                    class: "btn mt-3 d-block text-center"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("span", { class: "border-style" }, "Edit", -1)
                    ])),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ]))
    ]),
    _: 1
  }))
}